$(document).ready(function() {
  $('[data-fancybox]').fancybox({
	  closeExisting: true,
	  smallBtn: false,
	  toolbar: false,
	  touch: false,
  });
});
